import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'getIndex',
    pure: true
})
export class GetIndexPipe implements PipeTransform {
    transform<T>(value: T, source: T[] | null | undefined, fallback: number = -1): number {
        if (!source?.length) {
            return fallback;
        }

        const index = source.indexOf(value);
        return index >= 0 ? index : fallback;
    }
}
